import { LoadingSpinner } from "components";
import "./Form.scss";
import React from "react";

type FormProps = {
  onSubmit: any;
  submitButtonName: string;
  isLoading: boolean;
  errorText: string;
  children?: any;
  childrenAfterSubmitButton?: any;
};

const Form = React.forwardRef((props: FormProps, ref: React.LegacyRef<HTMLFormElement>) => {
  return (
    <div className="ui-form-div">
      <form autoComplete="off" className="ui-form" onSubmit={props.onSubmit} ref={ref}>
        {props.children}

        {props.errorText !== "" && <div className="error">{props.errorText}</div>}

        <button type="submit" className="submit-button">
          {props.isLoading ? <LoadingSpinner /> : props.submitButtonName}
        </button>

        {props.childrenAfterSubmitButton}
      </form>
    </div>
  );
});

export default Form;
